export default "__VITE_ASSET__iCP2dFoI__"